import { createContext } from '@fluentui/react-context-selector';
export var MenuContext = createContext({
  activeIndex: -1,
  variables: {},
  onItemClick: null,
  slotProps: {
    item: {},
    divider: {}
  },
  behaviors: {
    item: undefined,
    divider: undefined
  },
  slots: {
    menu: null
  }
}, {
  strict: false
});
export var MenuContextProvider = MenuContext.Provider;
//# sourceMappingURL=menuContext.js.map
